// extracted by mini-css-extract-plugin
export default {"root":"Search_root__2B24t","icon":"Search_icon__2HMsG","submit":"Search_submit__3iZ8u"};